import { getBrowserTimezone } from '@mi-front/core';
import { useTimezoneCtx } from '../context/timezone';

export function useTimezone(): string {
  const ctx = useTimezoneCtx();

  return ctx?.timezone || getBrowserTimezone();
}

export { useDialog } from './useDialog';
export type { UseDialogReturn } from './useDialog';
export { useHoverPopover } from './useHoverPopover';
export type { AnchorPosition, UseHoverPopoverOptions } from './useHoverPopover';
export { useUnsavedChangesWarning } from './useUnsavedChangesWarning';
export { useBreakpointsDown } from './useBreakpointsDown';
export { useScrollToTop } from './useScrollToTop';
